import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';

import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: "transparent",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  stepper: {
    backgroundColor: "transparent",
  }
}));

function getSteps() {
  return ['9/23 Regular Registration Deadline', '9/30 Late Registration Deadline', 
  '10/3 Teams notified of acceptance', '10/5 Teams must confirm acceptance',
 '10/7 Post Registration Packet Release', '10/28 Post Registration Phase 1 Deadline',
'11/7 Post Registration Phase 2 Deadline', '11/14 Post Registration Phase 3 Deadline', 
'11/18 Team Mixer', '11/19 Bhangra in the Burgh XVI!!'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return `Use the portal to complete the application. All details and requirements for the application are visible once you \n sign up with your team email. The registration fee for this deadline is $120. This fee will not be refunded under \n any circumstances.`;
    case 1:
      return 'The portal will be open until this date. There will be no exceptions for late deadlines. The registration fee for this deadline \n is $140. This fee will not be refunded under any circumstances.';
    case 2:
      return `The Bhangra in the Burgh XVI Executive Board will review only fully completed applications that are received no later \n than 11:59 pm on Friday, September 30th. Teams will be judged for selection similar to how they would be judged on the \n day of the show. Day-of-show Judging Criteria is attached below. The top eight teams are selected to compete.`;
    case 3: 
      return `By October 3rd, teams will be notified of their entry status. Within 48 hours, teams will be expected to confirm participation \n and will then receive supplemental information in the following five business days.`
    case 4: 
      return `The post registration packet will be released to teams that have confirmed their participation`
    case 5:
      return `Roster and forms items are due`
    case 6:
        return `Travel info and fee items are due`
    case 7:
        return `Lighting cues, mix, intro vid items are due`
    case 8: 
        return `Teams will travel to Carnegie Mellon University campus. The BIB XVI Executive Board will welcome teams at mixer!`
    case 9:
        return `Get hyped!`
    default:
      return 'Fill in information';
  }
}

export default function Timeline() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={classes.root}>
      <Stepper nonLinear activeStep={activeStep} orientation="vertical" className={classes.stepper}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton onClick={handleStep(index)}>
              {label}
            </StepButton>
            <StepContent>
              <Typography style={{ display: "inline-block", whiteSpace: "pre-line" }}>{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}